import { isNumber } from '@/utils/validate'
import BigNumber from 'bignumber.js'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'

/**
 * 格式化数字 ,不进行四舍五入， 直接截留指定小数位
 * @param number
 * @param precision
 * @param isRound 是否进行四舍五入，此方法就是不进行四舍五入，故默认否
 */
export function formatNumber(number, precision = 0, isRound = true) {
  if (isNumber(number) && precision >= 0) {
    if (isRound) {
      // return (Math.round(number * Math.pow(10, precision)) / Math.pow(10, precision)).toFixed(precision)
      return roundHalfUp(number, precision).toFixed(precision)
    }
    const re = `([0-9]+\.[0-9]{${precision}})[0-9]*`
    const val = (number + '').replace(new RegExp(re, 'g'), '$1')
    return Number(val).toFixed(precision)
    // 有bug
    // return (parseInt(number * Math.pow(10, precision + 1)) / Math.pow(10, precision + 1)).toFixed(precision)
  }
  return (number)
}

// 根据币种，进行金额的小数位数、进位规则
export function formatNumberByCurrency(number, precision = 0, currency) {
  if (!number) return (number)
  if (RateUtil.useAmountCarryRule()) {
    const num = Number(number)
    if (isNumber(num) && num > 0 && precision >= 0 && !!currency) {
      try {
        let scale = 2 // 小数位数
        let carryRule = 0 // 进位规则：0=四合五入、1=舍位
        const currencyData = RateUtil.getCurrency(currency)
        if (currencyData !== null) {
          scale = currencyData.defaultFractionDigits
          carryRule = currencyData.carryRule
        }
        if (carryRule === 1) { // 1=舍位
          return formatNumber(num, scale, false)
        } else {
          return formatNumber(ToFixed2(num, scale), scale, false)
        }
      } catch (e) {
        return formatNumber(num, precision)
      }
    }
  } else {
    return formatNumber(number, precision)
  }
  return (number)
}

/**
 * 把字符串转换为数字
 */
export function parseNumber(parseString, precision) {
  if (!parseString) { return 0.00 }
  return Number(formatNumber(Number(parseString), precision))
}

/**
 * 格式化数字 ,进行四舍五入
 * @param number
 * @param precision
 */
export function formatRoundNumber(number, precision = 0) {
  if (isNumber(number) && precision >= 0) {
    // return (Math.round(number * Math.pow(10, precision)) / Math.pow(10, precision)).toFixed(precision)
    return roundHalfUp(number, precision).toFixed(precision)
  }
  // 注意：Number 后，移除了最后的小数0
  return Number(number)
}

/**
 * 四舍五入: CARGO-6875，NumberUtils.rountHalfUp: 25 * 6.967 = 174.17499999999998 ，四舍五入2位后 174.17
 * 从 原flex=》NumberUtils.js 迁移过来的
 */
export function roundHalfUp2(number, scale = 2) {
  return parseNumber(ToFixed(number, scale), scale)
}

/**
 * 四舍五入
 * @param number
 * @param scale
 * @returns {Number}
 */
export function roundHalfUp(number, scale = 2) {
  if (isNaN(number)) return 0
  const sign = (number < 0) ? -1 : 1
  const numbers = Math.abs(number) + ''
  const precision = numbers.split('.')[1] ? numbers.split('.')[1].length : 0
  // CARGO-13571，按发票销账会有一分钱的误差：110 * 6.4895 = 713.8449999999999，保留 2位小数，会按 713.84
  if (precision && precision > 8) {
    const six = Math.pow(10, 8)
    number = Math.round((number * sign) * six) / six * sign
  }
  const n = Math.pow(10, scale)
  return Math.round((number * sign) * n) / n * sign
}
/**
 * 自定义四舍五入算法 从ChargeUtils中迁移过来的
 */
export function ToFixed(value, digits = 0) {
  return roundHalfUp(value, digits)
}

/**
 * 四舍五入: 1.5470000000000006; 调用roundHalfUp2还是会有尾巴
 */
export function roundHalfUp3(number, scale = 2) {
  return Number(ToFixed(number, scale))
}

/**
 * CARGO-23739：6.500000*722.19=4694.235000000001：4694.235，四舍五入: 4694.23
 * (roundHalfUp、roundHalfUp2、roundHalfUp3都没有进位 4694.24)
 */
export function roundHalfUp4(number, scale = 2) {
  return BigNumber(number).dp(scale, BigNumber.ROUND_HALF_UP).toNumber()
}

export function numericCompare(a, b) {
  if (isNaN(a) && isNaN(b)) {
    return 0
  }

  if (isNaN(a)) {
    return 1
  }

  if (isNaN(b)) {
    return -1
  }

  if (a < b) {
    return -1
  }
  if (a > b) {
    return 1
  }
  return 0
}
export function ToFixed2(value, digits = 0) {
  // CARGO-7745，25 * 6.967 = 174.17499999999998，要进位； 2101.92 * 0.060566 = 127.30488672000001，不要进位。与后台先默认8位小数
  const n = Math.pow(10, 8)
  value = Math.round(value * n) / n

  let str = value.toString()
  let isNegative
  if (str.indexOf('-') > -1) {
    str = Math.abs(value).toString()
    isNegative = true
  }
  const index = str.indexOf('.')
  let strInt = str
  let strDec = ''
  if (index > 0) {
    strInt = str.substr(0, index)
    strDec = str.substr(index + 1, digits)
  }
  while (strDec.length < digits) {
    strDec += '0'
  }
  let integer = Number(strInt + strDec)

  if (index > 0) {
    const nums = []
    const dec = str.substr(index + 1 + digits)// 取舍小数部分
    for (let i = 0; i < dec.length; i++) {
      nums.push(Number(dec.charAt(i)))// 拆分每个数字
      // CARGO-7624，4408发票00105482，其中一笔USD 65.71，汇率 6.6957，在销账界面：439.974447，四舍五入 439.98。会比BigDecimal多出0.01
      break
    }
    let n1
    let n2
    while (nums.length > 1) {
      n1 = nums.pop()
      if (n1 > 4) {
        n2 = nums[nums.length - 1] + 1
        nums[nums.length - 1] = n2
      }
    }
    if (nums.length > 0 && nums[nums.length - 1] > 4) { integer++ }
  }

  str = integer.toString()
  if (digits === 0) {
    if (isNegative) {
      str = '-' + str
    }
    return Number(str)
  }
  while (str.length < strInt.length + strDec.length) {
    str = '0' + str
  }
  let roundValue = str.substr(0, str.length - digits) + '.' + str.substr(str.length - digits)
  if (isNegative) {
    roundValue = '-' + roundValue
  }
  return Number(roundValue)
}

// 截断小数
export function truncateDecimals(number, precision) {
  if (precision >= 0) {
    const regExp = new RegExp(`([0-9]+\.[0-9]{${precision}})[0-9]*`)
    if (typeof number === 'number') {
      return Number(String(number).replace(regExp, '$1'))
    }
    if (typeof number === 'string' && isNumber(number)) {
      return number.replace(regExp, '$1')
    }
  }
  return number
}

// 判断字符串是否是纯数字
export function isNumberStr(str) {
  if (str === null || str === undefined) {
    return false
  }
  return /^\d+$/.test(str)
}
